import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';
import { ROLE_ADMIN, ROLE_RENTER } from '../../constants/roles';

const StandsApiService = {

  getStands(token, role) {
    return axios
      .get(`${getBackOfficeRoute(role)}/stands`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  postAdminStands(token, data) {
    return axios
      .post(`${getBackOfficeRoute(ROLE_ADMIN)}/stands`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  putStands(token, standId, data) {
    return axios
      .put(`${getBackOfficeRoute(ROLE_RENTER)}/stands/${standId}`, data, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },
};

export default StandsApiService;



// WEBPACK FOOTER //
// ./src/services/api/StandsApiService.js